import { c as _c } from "react/compiler-runtime";
import { Apartment } from "@mui/icons-material";
import React from "react";
import { Text, TextSize, TextWeight } from "../../components";
const AddressCard = t0 => {
  const $ = _c(49);
  const {
    address,
    onEdit,
    onDelete,
    className,
    showRadio: t1,
    isSelected: t2,
    onSelect,
    radioName: t3
  } = t0;
  const showRadio = t1 === undefined ? false : t1;
  const isSelected = t2 === undefined ? false : t2;
  const radioName = t3 === undefined ? "address" : t3;
  let t4;
  if ($[0] !== address.id || $[1] !== onSelect) {
    t4 = () => {
      if (onSelect && address.id) {
        onSelect();
      }
    };
    $[0] = address.id;
    $[1] = onSelect;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const handleRadioChange = t4;
  const t5 = `min-w-[230px] bg-white border border-gray-200 p-6 shadow-sm transition-shadow ${className}`;
  let t6;
  if ($[3] !== address.id || $[4] !== handleRadioChange || $[5] !== isSelected || $[6] !== radioName || $[7] !== showRadio) {
    t6 = showRadio && <input type="radio" name={radioName} value={address.id} checked={isSelected} onChange={handleRadioChange} className="w-4 h-4 accent-black border-gray-300 focus:ring-black cursor-pointer" />;
    $[3] = address.id;
    $[4] = handleRadioChange;
    $[5] = isSelected;
    $[6] = radioName;
    $[7] = showRadio;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== address.alias) {
    t7 = <Text text={address.alias} weight={TextWeight.BOLD} />;
    $[9] = address.alias;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <div className="flex items-center space-x-3">{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== onEdit) {
    t9 = onEdit && <button onClick={e => {
      e.stopPropagation();
      onEdit();
    }} className="text-gray-500 hover:text-gray-800 text-sm font-medium">Edytuj</button>;
    $[14] = onEdit;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== onDelete || $[17] !== showRadio) {
    t10 = !showRadio && onDelete && <><span className="text-gray-300">/</span>{onDelete && <button onClick={onDelete} className="text-red-600 hover:text-red-800 text-sm font-medium">Usuń</button>}</>;
    $[16] = onDelete;
    $[17] = showRadio;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className="flex items-center space-x-2">{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t8) {
    t12 = <div className="flex justify-between items-start mb-4">{t8}{t11}</div>;
    $[22] = t11;
    $[23] = t8;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== address.company) {
    t13 = address.company && <div className="flex items-center space-x-2"><Apartment className="text-gray-400 !text-[16px]" /><Text text={address.company} fontSize={TextSize.S} /></div>;
    $[25] = address.company;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== address.vatNumber) {
    t14 = address.vatNumber && <Text text={`NIP: ${address.vatNumber}`} fontSize={TextSize.S} />;
    $[27] = address.vatNumber;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const t15 = `${address.firstname} ${address.lastname}`;
  let t16;
  if ($[29] !== t15) {
    t16 = <Text text={t15} fontSize={TextSize.S} />;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = `${address.address1} ${address.address2}`;
  let t18;
  if ($[31] !== t17) {
    t18 = <Text text={t17} fontSize={TextSize.S} />;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  const t19 = `${address.postcode} ${address.city}`;
  let t20;
  if ($[33] !== t19) {
    t20 = <Text text={t19} fontSize={TextSize.S} />;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  const t21 = `${address.phone || address.phoneMobile}`;
  let t22;
  if ($[35] !== t21) {
    t22 = <Text text={t21} fontSize={TextSize.S} />;
    $[35] = t21;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== t13 || $[38] !== t14 || $[39] !== t16 || $[40] !== t18 || $[41] !== t20 || $[42] !== t22) {
    t23 = <div className="flex flex-col text-gray-700">{t13}{t14}{t16}{t18}{t20}{t22}</div>;
    $[37] = t13;
    $[38] = t14;
    $[39] = t16;
    $[40] = t18;
    $[41] = t20;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== handleRadioChange || $[45] !== t12 || $[46] !== t23 || $[47] !== t5) {
    t24 = <div className={t5} onClick={handleRadioChange}>{t12}{t23}</div>;
    $[44] = handleRadioChange;
    $[45] = t12;
    $[46] = t23;
    $[47] = t5;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  return t24;
};
export default AddressCard;